var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"anchor-linked-block",attrs:{"id":_vm.observerId,"data-external":"anchor-linked-block"}},[_c('BaseHeading',{staticClass:"anchor-linked-block__block-title",attrs:{"id":_vm.blockTitleId,"level":4,"title":_vm.blockTitle}}),_vm._v(" "),_c('CMSRenderer',{attrs:{"content":_vm.blockContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }